import React from 'react';
import { makeStyles } from '@material-ui/core';
import DoneIcon from '@material-ui/icons/Done';

const useStyles = makeStyles({
  label: {
    userSelect: 'none',
    cursor: 'pointer',
    fontSize: '0.8125rem',
    display: 'flex',
    alignItems: 'center'
  },
  dumbCheckbox: {
    position: 'relative',
    width: '20px',
    height: '20px',
    minWidth: '20px',
    borderRadius: '4px',
    border: '1px solid',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  text: {
    marginLeft: '0.8125rem',
    lineHeight: '1'
  },
  input: {
    position: 'absolute',
    visibility: 'hidden'
  },
  icon: { color: '#fff', fontSize: '1rem', fontWeight: 'bold' }
});

interface CheckboxCustomProps {
  onChange: Function;
  isChecked: boolean;
  label?: string;
}

const CheckboxCustom = ({
  onChange,
  isChecked,
  label
}: CheckboxCustomProps) => {
  const classes = useStyles();
  return (
    <label className={classes.label}>
      <div
        className={classes.dumbCheckbox}
        style={{
          backgroundColor: isChecked ? '#656565' : '#fff',
          borderColor: isChecked ? 'none' : '#656565'
        }}
      >
        {isChecked && <DoneIcon className={classes.icon} />}
        <input
          className={classes.input}
          type="checkbox"
          onChange={(e: any) => onChange(e)}
          checked={isChecked}
        />
      </div>
      {label && <span className={classes.text}>{label}</span>}
    </label>
  );
};

export default CheckboxCustom;
